import React from 'react';
import { useDispatch } from 'react-redux';
import useToggleTranslate from 'hooks/useToggleTranslate';
import style from './autotranslatedialog.module.scss';
import useApp from 'hooks/useApp';
import { setAutoTranslateConfirm } from 'store/app/app.actions';
import { getFlagAndDemonym } from 'utils';
import classNames from 'classnames'
import Popup from 'reactjs-popup';

interface Props { }


const DEFAULTS = {
    AUTO_TRANSLATE_TEXT: `The webchat language is English by default. It looks like you are speaking another language; would you like us to automatically:`,
    REJECT_TRANSLATE_TEXT: `No, English is ok`,
    ACCEPT_TRANSLATE_TEXT: 'Translate to ${LANGUAGE_NAME}'
}

const AutoTranslateDialog: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    const { translation, autoTranslateConfirm, autoTranslationConfig } = useApp();

    const toggleTranslate = useToggleTranslate();

    const autoTranslateText = autoTranslationConfig?.textConfig?.message ?? DEFAULTS.AUTO_TRANSLATE_TEXT;
    const rejectTranslateText = autoTranslationConfig?.textConfig?.reject ?? DEFAULTS.REJECT_TRANSLATE_TEXT;

    return (
        <Popup closeOnDocumentClick={false} open={autoTranslateConfirm}>
            <div className={style.wrapper}>
                <p className={style.message}>{autoTranslateText}</p>
                <div className="row column">
                    {translation?.detectedLanguages.map(lang => (
                        <button key={lang} className={classNames(style.okButton, style.button)} onClick={() => {
                            dispatch(setAutoTranslateConfirm(false));
                            toggleTranslate(lang, true);
                        }}>
                            {getAcceptMessage(getFlagAndDemonym({
                                targetLanguage: lang,
                                sourceLanguage: lang
                            }), autoTranslationConfig?.textConfig?.accept)}
                        </button>
                    ))}
                    <button className={classNames(style.cancelButton, style.button)} onClick={() => dispatch(setAutoTranslateConfirm(false))}>
                        {rejectTranslateText}
                    </button>
                </div>
            </div>
        </Popup>
    )
}

const getAcceptMessage = ([flag, demonym]: string[], acceptMessage: string = DEFAULTS.ACCEPT_TRANSLATE_TEXT) =>
    acceptMessage.replaceAll('${LANGUAGE_NAME}', demonym).replaceAll('${LANGUAGE_FLAG}', flag).trim()


export default AutoTranslateDialog;
